import { render, staticRenderFns } from "./TorInvolvementChecker.vue?vue&type=template&id=e712f6b4&scoped=true&"
import script from "./TorInvolvementChecker.vue?vue&type=script&setup=true&lang=js&"
export * from "./TorInvolvementChecker.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e712f6b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
